import { Switch, Typography, Stack } from '@cast/design-system';

import { useFeedbackToolbar } from './feedback-toolbar-state';

export const FeedbackToolbar = () => {
  const hidden = useFeedbackToolbar((s) => s.hidden);
  const toggle = useFeedbackToolbar((s) => s.toggle);

  return (
    <Stack height="100%" py={8} gap={8}>
      <Stack direction="row" alignItems="center" gap={8}>
        <Typography variant="P12M">Feedback Toolbar</Typography>
        <Switch size="sm" checked={!hidden} onChange={toggle} />
      </Stack>
    </Stack>
  );
};
